import { EventBus } from "../../../eventbus";
import { bytesToString, stringToBytes } from "../../../functions/fileSizeCalc";
import { WritableStream } from "web-streams-polyfill";
import streamSaver from "streamsaver";
import { errorDispatch } from "../../../functions/errorDispatch";
import { baseUrl } from "../../../config";

export default {
  props: {
    itemData: Object,
  },
  data() {
    return {
      downloadName: "",
      size: "",
    };
  },
  created() {
    this.getFiles();

    this.setBtn(true);
  },
  methods: {
    setBtn(val) {
      if (this.itemData.btn) {
        this.itemData.btn.disabled = val;
      }
    },
    selectedType(need) {
      return this.itemData.type === need;
    },
    getFilesAndFolders() {
      const date = new Date();

      switch (this.itemData.type) {
        case "multi":
          this.downloadName = `mySheprdDownload-${date.getDate()}-${
            date.getMonth() + 1
          }-${date.getFullYear()}.zip`;

          //calc size
          this.calcSize();

          return this.itemData.items;

        case "file":
          this.downloadName = `${this.itemData.name}-${this.itemData.extension}`;
          return {
            selectedFiles: [this.itemData.item],
            selectedFolders: [],
          };

        case "folder":
          this.downloadName = `mySheprdDownload-${date.getDate()}-${
            date.getMonth() + 1
          }-${date.getFullYear()}.zip`;
          return {
            selectedFiles: [],
            selectedFolders: [this.itemData.item],
          };
      }
    },
    createDownloadLink() {
      const items = this.getFilesAndFolders();
      let downloadLink = `${baseUrl}/download?`;

      downloadLink += `files=${JSON.stringify(
        items.selectedFiles.map((file) =>
          file.file_id ? file.file_id : file.id
        )
      )}`;

      downloadLink += `&folders=${JSON.stringify(
        items.selectedFolders.map((folder) =>
          folder.folder_id ? folder.folder_id : folder.id
        )
      )}`;

      downloadLink += `&company=${this.$store.state.company}`;

      if (this.$store.state.user) {
        downloadLink += `&key=${this.$store.state.user.key}`;
      }

      return downloadLink;
    },
    calcSize() {
      let totalSize = 0;

      this.itemData.items.selectedFiles.forEach((file) => {
        totalSize += stringToBytes(file.size);
      });

      const str = bytesToString(totalSize);

      this.size = `${str.value} ${str.unit}`;
    },
    getFiles() {
      fetch(this.createDownloadLink())
        .then((response) => {
          let contentDisposition = response.headers.get("Content-Disposition");

          let fileName = contentDisposition
            ? contentDisposition.substring(
                contentDisposition.lastIndexOf("=") + 1
              )
            : "file";

          //enable btn
          this.setBtn(false);

          //close self
          EventBus.$emit(`closeallactions`);

          // These code section is adapted from an example of the StreamSaver.js
          // https://jimmywarting.github.io/StreamSaver.js/examples/fetch.html

          // If the WritableStream is not available (Firefox, Safari), take it from the ponyfill
          if (!window.WritableStream) {
            streamSaver.WritableStream = WritableStream;
            window.WritableStream = WritableStream;
          }

          const fileStream = streamSaver.createWriteStream(fileName);
          const readableStream = response.body;

          // More optimized
          if (readableStream.pipeTo) {
            return readableStream.pipeTo(fileStream);
          }

          window.writer = fileStream.getWriter();

          const reader = response.body.getReader();
          const pump = () =>
            reader
              .read()
              .then((res) =>
                res.done ? writer.close() : writer.write(res.value).then(pump)
              );

          pump();
        })
        .catch((error) => {
          errorDispatch("dowload");
        });
    },
  },
};
